/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InvestmentStyleDiagnosisMeetingQuestion model module.
 * @module model/InvestmentStyleDiagnosisMeetingQuestion
 * @version 1.0.0
 */
class InvestmentStyleDiagnosisMeetingQuestion {
    /**
     * Constructs a new <code>InvestmentStyleDiagnosisMeetingQuestion</code>.
     * 面談で聞くと良い質問（1件）
     * @alias module:model/InvestmentStyleDiagnosisMeetingQuestion
     */
    constructor() { 
        
        InvestmentStyleDiagnosisMeetingQuestion.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentStyleDiagnosisMeetingQuestion</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentStyleDiagnosisMeetingQuestion} obj Optional instance to populate.
     * @return {module:model/InvestmentStyleDiagnosisMeetingQuestion} The populated <code>InvestmentStyleDiagnosisMeetingQuestion</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentStyleDiagnosisMeetingQuestion();

            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('source')) {
                obj['source'] = ApiClient.convertToType(data['source'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentStyleDiagnosisMeetingQuestion</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentStyleDiagnosisMeetingQuestion</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }
        // ensure the json data is a string
        if (data['source'] && !(typeof data['source'] === 'string' || data['source'] instanceof String)) {
            throw new Error("Expected the field `source` to be a primitive type in the JSON string but got " + data['source']);
        }

        return true;
    }


}



/**
 * 質問テンプレートのキー
 * @member {module:model/InvestmentStyleDiagnosisMeetingQuestion.KeyEnum} key
 */
InvestmentStyleDiagnosisMeetingQuestion.prototype['key'] = undefined;

/**
 * 本人が選択した項目か、不足分を補完した項目か
 * @member {module:model/InvestmentStyleDiagnosisMeetingQuestion.SourceEnum} source
 */
InvestmentStyleDiagnosisMeetingQuestion.prototype['source'] = undefined;





/**
 * Allowed values for the <code>key</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisMeetingQuestion['KeyEnum'] = {

    /**
     * value: "monthly_real_cost"
     * @const
     */
    "monthly_real_cost": "monthly_real_cost",

    /**
     * value: "vacancy_cost"
     * @const
     */
    "vacancy_cost": "vacancy_cost",

    /**
     * value: "interest_rate_rise"
     * @const
     */
    "interest_rate_rise": "interest_rate_rise",

    /**
     * value: "rent_decline"
     * @const
     */
    "rent_decline": "rent_decline",

    /**
     * value: "repair_cost"
     * @const
     */
    "repair_cost": "repair_cost",

    /**
     * value: "sale_price"
     * @const
     */
    "sale_price": "sale_price",

    /**
     * value: "tax_effect"
     * @const
     */
    "tax_effect": "tax_effect",

    /**
     * value: "unfit_case"
     * @const
     */
    "unfit_case": "unfit_case",

    /**
     * value: "comparison"
     * @const
     */
    "comparison": "comparison",

    /**
     * value: "loan_consult"
     * @const
     */
    "loan_consult": "loan_consult",

    /**
     * value: "support_detail"
     * @const
     */
    "support_detail": "support_detail"
};


/**
 * Allowed values for the <code>source</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisMeetingQuestion['SourceEnum'] = {

    /**
     * value: "user_selected"
     * @const
     */
    "user_selected": "user_selected",

    /**
     * value: "auto_safety"
     * @const
     */
    "auto_safety": "auto_safety"
};



export default InvestmentStyleDiagnosisMeetingQuestion;

